<template>
  <el-dialog
      :model-value="dialog"
      width="25%"
      :before-close="handlerClose"
      class="dialogPhotoToPost"
  >
    <el-row class="addPhoto-main-div">
      <el-col :span="24">
        <span class="addPhoto-header"> {{ $t('posts.attachPhoto') }} </span>
      </el-col>
      <el-col :span="24" class="addPhoto-container">
        <div class="tabs">
          <div @click="activeTab = 0">{{ $t('photos.myAlbum') }}</div>
          <div @click="activeTab = 1">{{ $t('photos.downloadPhoto') }}</div>
        </div>

        <div class="divContent" v-if="activeTab === 0">
          <div v-if="albumPhotos.length !== 0">
            <el-row :gutter="16">
              <el-col v-for="photo in albumPhotos" :key="photo.id" :span="8">
                <div class="grid-content bg-purple">
                  <div style="position: relative">
                    <el-image
                        style="border-radius: 16px; width: 100%; height: 150px"
                        :src="`${$imageURL}api/Photo?id=${photo.id}`"
                        fit="cover"
                    >
                    </el-image>
                    <el-checkbox
                        size="medium"
                        style="position: absolute; top: 10px; right: 10px"
                        v-model="photo.isSelected"
                        false-label="true"
                        @change="switchSelection(photo.id)"
                    ></el-checkbox>
                  </div>
                  <div class="description">{{ photo.description }}</div>
                  <div class="date">{{ photo.createdDate }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-else class="addPhoto-empty">{{$t('photos.noPhotoInAlbum')}}</div>
        </div>
        <div class="divContent" v-if="activeTab === 1">
          <div v-if="uploadedPhotos.length !== 0">
            <el-row :gutter="20">
              <el-col :span="8" v-for="photo in uploadedPhotos" :key="photo.id">
                <div style="position: relative">
                  <el-image
                      style="border-radius: 16px; width: 100%; height: 150px"
                      :src="photo.base64"
                      fit="cover"
                  ></el-image>
                  <button class="addPhoto-button-trash" @click="deleteUploadPhoto(photo.id)"><i class="fas fa-trash"></i>
                  </button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>

      <el-col :span="24" style="display: flex; justify-content: space-between" class="addPhoto-action">
        <el-upload
            action=""
            :accept="allowedTypes.mime.reduce((rule, mime) => rule + ',' + mime)"
            :auto-upload="false"
            multiple
            :on-change="fileChange"
            :show-file-list="false"
            :limit="10"
            class="addPhoto-upload"
            v-if="activeTab === 1"
        >
          <button>{{ $t('common.add') }}</button>
        </el-upload>
        <button @click="save" class="addAttach-save-button">{{ $t('posts.attach') }}</button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import {MESSAGE_PHOTO_TYPES} from "@/constants"
export default {
  name: "AddMessagePhoto",
  props: ["dialog","unselectedPhoto", "clean"],
  emits: ["closeDialog", "attachPhoto","delete-uploaded"],
  data() {
    return {
      activeTab:0,

      //TODO: надо бы перенести хранение на сервер и получение оттуда
      allowedTypes: {
        mime: ["image/jpeg", "image/png"],
        extensions: [".jpeg", ".jpg", ".png"]
      },

      photoStates: {
        none: null,
        selected: "selected",
        unselected: "unselected"
      },

      refreshAlbumPhotos: true,

      photos: [],
    };
  },
  computed:{
    albumPhotos(){
      return this.photos.filter(photo => photo.type === MESSAGE_PHOTO_TYPES.ALBUM)
    },
    uploadedPhotos(){
      return this.photos.filter(photo => photo.type === MESSAGE_PHOTO_TYPES.UPLOADED)
    }
  },
  watch: {
    refreshAlbumPhotos() {
        this.getAlbumPhotos();
    },
    unselectedPhoto(newValueArray){
      if(!newValueArray) return
      let newValue = newValueArray[0]
      let photo = this.photos.find(photo => photo.id === newValue.id)
      if(photo.type === MESSAGE_PHOTO_TYPES.ALBUM){
        photo.state.current = this.photoStates.unselected
        photo.isSelected = false
      }
      if(photo.type === MESSAGE_PHOTO_TYPES.UPLOADED){
        this.photos = this.photos.filter(p => p.id !== photo.id)
      }
    },
    clean(newValueArray){
      if(newValueArray[0])
        this.photos = []
        this.refreshAlbumPhotos = true
        this.activeTab = 0
    }
    },
  methods: {
    switchSelection(id){
      let photo = this.photos.find(photo=>photo.id === id)

      if(photo.state.previous === this.photoStates.none)
        photo.state.previous = photo.state.current

      photo.isSelected = !photo.isSelected

      photo.state.current = photo.isSelected ? this.photoStates.selected : this.photoStates.unselected
    },

    createPhotoObject(id, type, base64, file, description, createdDate) {
      return {
        id, type, base64, file, description, createdDate,
        state: {
          previous: this.photoStates.none,
          current: this.photoStates.unselected
        },
        isSelected: false
      }
    },

    handlerClose() {
      //откатили обратно статусы всех фото
      this.photos.forEach(photo =>
      {
        if(photo.state.previous === this.photoStates.none) return
        photo.isSelected = photo.state.previous === this.photoStates.selected
        photo.state.current = photo.state.previous
        photo.state.previous = this.photoStates.none
      })
      this.photos = this.photos.filter(photo=>!(photo.type === MESSAGE_PHOTO_TYPES.UPLOADED
          && photo.state.current === this.photoStates.unselected))

      this.$emit("closeDialog");
    },

    async getAlbumPhotos() {
        if(this.refreshAlbumPhotos !== true) return

        let response = await this.$http.get("api/Photo/GetMyPhoto");

        let albumPhotos = response.data
            .map(photo => this.createPhotoObject(photo.id, MESSAGE_PHOTO_TYPES.ALBUM, null,null, photo.description, photo.createdDate))

        this.photos.push(...albumPhotos)
        this.refreshAlbumPhotos = false
    },

    async save() {
      //удаляем загруженные, которые отметили на удаление
      this.photos = this.photos.filter(photo=>!(photo.type === MESSAGE_PHOTO_TYPES.UPLOADED
          && photo.state.current === this.photoStates.unselected))
      // обнуляем предыдущее состояние в фотографиях
      this.photos.forEach(photo => photo.state.previous = this.photoStates.none)

      this.$emit("attachPhoto", this.photos.filter(x=>x.isSelected));
    },

    async fileChange(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file.raw);

      if (!this.allowedTypes.mime.some(mime => mime === file.raw.type)) {
        return
      }

      reader.onload = () => {
        let id = file.raw.uid
        let type = MESSAGE_PHOTO_TYPES.UPLOADED
        let base64 = reader.result

        let photo = this.createPhotoObject(id, type, base64, file.raw);
        this.photos.push(photo)
        this.switchSelection(photo.id)
      }
    },

    async deleteUploadPhoto(id) {
      this.photos = this.photos.filter(photo => photo.id !== id)
      this.$emit('delete-uploaded', id)
    }
    },
  async created(){
    await this.getAlbumPhotos()
  }
};
</script>

<style lang="scss">
.dialogPhotoToPost > .el-dialog__header {
  display: none;
}

.dialogPhotoToPost > .el-dialog__body {
  padding: 0;
}

.dialogPhotoToPost {
  box-shadow: none;
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: 400;
  background: var(--photo-background);
  color: var(--photo-text);
  min-height: 600px;
}

.addPhoto-main-div {
  padding: 20px 15px;
}
.addPhoto-container {
  overflow-y: auto;
  margin-bottom: 20px;
}
.addPhoto-main-div .addPhoto-header {
  font-size: 20px;
  font-weight: 700;
  color: var(--photo-text);
  line-height: 24px;
}

.addPhoto-action button {
  background: #006EFF;
  border-radius: 5px;
  padding: 15px 0;
  border: none;
  outline: none;
  color:var(--whiteText);
  width: 98%;
}

.addPhoto-action .addPhoto-upload {
  width: 98%;
}

.addPhoto-action .addPhoto-upload .el-upload--text {
  width: 100%;
  height: 100%;
}

.addPhoto-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: var(--photo-text);
}

.addPhoto-button-trash {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 10px;
  color: var(--labelText);
  border-radius: 50%;
  border: none;
  padding: 8px;
}

.divContent {
  margin-top: 20px;
  min-height: 550px;
  height: 550px;
  width: calc(100% - 16px);
}

.tabs {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.tabs > div {
  background: var(--photo-background);
  border-radius: 5px;
  padding: 11px 0;
  width: 48%;
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: var(--blueColor);
  cursor: pointer;
}
</style>
